(function () {
  angular
    .module("akitabox.ui.dialogs.decommission")
    .factory("DecommissionDialog", DecommissionDialog);

  /* @ngInject */
  function DecommissionDialog($log, $mdDialog, $mdMedia, $q) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/decommission/decommission.dialog.html",
      controller: "DecommissionDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    return {
      show: show,
    };

    /**
     * @param {object} options
     * @param {object} options.locals
     * @param {Asset} options.locals.asset - the asset to decommission
     * @return {Promise<void>}
     */
    function show(options) {
      var error = new Error("Sorry, we weren't able to complete your request");
      var hasErrored = false;

      if (!options) {
        $log.error("DecommissionDialog: no options provided");
        hasErrored = true;
      } else if (!options.locals) {
        $log.error("DecommissionDialog: no locals provided");
        hasErrored = true;
      } else if (!options.locals.asset && !options.locals.room) {
        $log.error("DecommissionDialog: no room/asset provided");
        hasErrored = true;
      }

      if (hasErrored) {
        return $q.reject(error);
      }

      return $mdDialog.show(angular.extend({}, modal, options));
    }
  }
})();
